<template>
  <tile-basic
    class="is-grey"
    :title="title">
    <template slot="top">
      <div class="tags">
        <b-tag
          v-for="field in getBaseFields(def)"
          :key="field.label">
          {{ field.label }}
        </b-tag>
        <b-tag
          v-for="field in attrs"
          :key="field.label">
          {{ field.label }}
        </b-tag>
        <b-tag
          v-for="field in related"
          :key="field.label">
          {{ field.label }}
        </b-tag>
      </div>
    </template>
  </tile-basic>
</template>

<script>
import _ from 'lodash';
import TileBasic from '@/components/TileBasic.vue';

export default {
  name: 'TileActionDataConfig',
  components: {
    TileBasic,
  },
  props: {
    title: {
      type: String,
      requried: true,
    },
    config: {
      type: Object,
      required: true,
    },
    def: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.getExtendedFields(this.def).forEach((f) => {
      if (this.config.attrs.includes(f.value)) {
        this.attrs.push(f);
      }
    });
    this.getRelatedFields(this.def).forEach((f) => {
      if (this.config.related.includes(f.type)) {
        this.attrs.push(f);
      }
    });
  },
  data() {
    return {
      attrs: [],
      related: [],
    };
  },
  methods: {
    getBaseFields(def) {
      return _.filter(def.fields, { coding: 'base' });
    },
    getExtendedFields(def) {
      return _.filter(def.fields, { coding: 'extended' });
    },
    getRelatedFields(def) {
      return _.filter(def.fields, { coding: 'related' });
    },
  },
};
</script>

<style lang="scss" scoped>

.tags {
  padding: $content-padding;

  .tag {
    background-color: #789;
  }
}

</style>
